import {pxToRem} from '../../utills/pxToRem'
import sizes from '../../theme/foundations/sizes'
import {fonts} from '../../theme/foundations/fonts'

const {lg} = sizes.container
const isDesktop = `@media (min-width: ${lg})`

const titleFont = {
    fontFamily: fonts.primary,
    fontWeight: 600,
    fontSize: pxToRem(14),
    lineHeight: '100%',
    letterSpacing: pxToRem(2),
    verticalAlign: 'middle',
    textTransform: 'uppercase',
    color: 'black',

    [isDesktop]: {
        fontSize: pxToRem(16),
        letterSpacing: pxToRem(2.4)
    }
}

const textFont = {
    fontFamily: fonts.primary,
    fontWeight: 400,
    fontSize: pxToRem(14),
    lineHeight: '100%',
    letterSpacing: pxToRem(1),
    verticalAlign: 'middle',
    textDecoration: 'none',
    color: 'black',

    [isDesktop]: {
        fontSize: pxToRem(16),
        letterSpacing: pxToRem(1.28)
    }
}

const copyFont = {
    fontFamily: fonts.primary,
    fontSize: pxToRem(12),
    lineHeight: '100%',
    fontWeight: 400,
    letterSpacing: pxToRem(1),
    verticalAlign: 'middle',
    textDecoration: 'none',
    color: 'black',

    [isDesktop]: {
        fontSize: pxToRem(13)
    }
}

const termsRowFont = {
    fontFamily: fonts.primary,
    fontWeight: 450,
    fontSize: pxToRem(14),
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    color: 'black',
    textAlign: 'center',
    textDecoration: 'none',

    [isDesktop]: {
        fontSize: pxToRem(16),
        letterSpacing: pxToRem(1.28)
    }
}

const termsRowChildStyles = {
    ...termsRowFont,
    display: 'inline',
    margin: 0,
    padding: 0,
    verticalAlign: 'baseline',

    [isDesktop]: {
        ...termsRowFont[isDesktop]
    }
}

const buttonFont = {
    fontFamily: fonts.primary,
    fontWeight: 700,
    fontSize: pxToRem(12),
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textAlign: 'center',
    verticalAlign: 'middle',
    textTransform: 'uppercase',
    color: 'white',

    [isDesktop]: {
        fontSize: pxToRem(14)
    }
}

const errorFont = {
    fontFamily: fonts.primary,
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: [`${pxToRem(1)} !important`],
    color: 'cav_red',
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(13), pxToRem(13)],
    fontStyle: 'italic'
}

const sectionTitleSpacing = {
    margin: 0,
    marginBottom: pxToRem(15),

    [isDesktop]: {
        marginBottom: pxToRem(30)
    }
}

const sectionItemSpacing = {
    marginTop: 0,
    marginBottom: pxToRem(15),

    [isDesktop]: {
        marginBottom: pxToRem(18)
    }
}

const sectionListStyles = {
    ul: {
        margin: 0,
        padding: 0,
        listStyle: 'none'
    },

    li: {
        listStyle: 'none',
        ...sectionItemSpacing,

        '&:last-child': {
            marginBottom: 0
        },

        '.footer__section-link, .footer__text-copy': {
            marginBottom: 0
        }
    },

    '.footer__section-link, .footer__text-copy': {
        ...sectionItemSpacing,
        display: 'block',

        '&:last-child': {
            marginBottom: 0
        }
    },

    '> .footer__section-link, > .footer__text-copy, > p:not(.footer__section-title)': {
        ...sectionItemSpacing,

        '&:last-child': {
            marginBottom: 0
        }
    }
}

const termsLinkHover = {
    '&:hover': {
        color: 'cav_hover_brightred',
        textDecoration: 'underline'
    }
}

export const footerLoadingMinHeight = {base: pxToRem(351), md: pxToRem(709)}

export const contentStyle = {
    position: 'relative',
    backgroundColor: 'cav_deep_light_gray',
    clear: 'both',
    height: '100%',
    padding: `${pxToRem(30)} ${pxToRem(11)}`,

    [isDesktop]: {
        padding: `${pxToRem(40)} ${pxToRem(45)}`
    },

    '&.footer--registered': {
        '.footer__registration-form': {
            display: 'none'
        }
    },

    '.pwa-content-asset': {
        display: 'contents'
    },

    '.content-asset': {
        display: 'contents'
    },

    '.footer__text-copy': {
        ...textFont
    },

    '.footer__container': {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gridTemplateRows: 'auto',
        rowGap: pxToRem(30),
        columnGap: pxToRem(10),

        [isDesktop]: {
            gridTemplateColumns: 'repeat(4, 1fr)',
            gridTemplateRows: 'auto auto',
            columnGap: pxToRem(80),
            rowGap: pxToRem(40)
        },

        '> #PWA-FOOTER-REGISTRATION': {
            gridColumn: '1 / span 2',
            gridRow: '1',
            width: '100%',

            [isDesktop]: {
                gridColumn: '1',
                gridRow: '1',
                width: 'auto'
            }
        },

        '> #PWA-FOOTER-SUPPORT': {
            gridColumn: '1',
            gridRow: '2',
            width: '100%',

            [isDesktop]: {
                gridColumn: '2',
                gridRow: '1',
                width: 'auto'
            }
        },

        '> #PWA-FOOTER-ABOUTUS': {
            gridColumn: '2',
            gridRow: '2',
            width: '100%',

            [isDesktop]: {
                gridColumn: '3',
                gridRow: '1',
                width: 'auto'
            }
        },

        '> #PWA-FOOTER-CUSTOMERSERVICE': {
            gridColumn: '1 / span 2',
            gridRow: '3',
            width: '100%',

            [isDesktop]: {
                gridColumn: '4',
                gridRow: '1',
                width: 'auto'
            }
        },

        '> #PWA-FOOTER-TERMS': {
            gridColumn: '1 / span 2',
            gridRow: '4',
            width: '100%',

            [isDesktop]: {
                gridColumn: '1 / span 4',
                gridRow: '2',
                width: '100%'
            }
        }
    },

    '.footer__section': {
        width: '100%',
        textAlign: 'left',

        [isDesktop]: {
            width: 'auto',
            textAlign: 'unset'
        },

        '&.footer__terms': {
            [isDesktop]: {
                width: '100%'
            }
        },

        '&:not(.footer__terms)': {
            ...sectionListStyles
        }
    },

    '.footer__section-title': {
        ...titleFont,
        fontWeight: 700,
        ...sectionTitleSpacing
    },

    '.footer__section-link': {
        ...textFont,
        '&:hover': {
            color: 'cav_hover_brightred',
            textDecoration: 'underline'
        }
    },

    '.footer__registration': {
        display: 'flex',
        flexDirection: 'column',
        gap: pxToRem(15),
        width: '100%',
        alignItems: 'center',

        [isDesktop]: {
            gap: pxToRem(20),
            width: pxToRem(472),
            alignItems: 'flex-start'
        }
    },

    '.footer__registration-error': {
        display: 'none',
        marginTop: pxToRem(8),
        marginBottom: 0,
        ...errorFont
    },

    '.footer__registration-logo': {
        alignSelf: 'center',
        height: 'auto',
        width: '80%',
        maxWidth: '80%',
        display: 'flex',
        justifyContent: 'center',

        [isDesktop]: {
            alignSelf: 'flex-start',
            width: pxToRem(220),
            height: pxToRem(41),
            maxWidth: pxToRem(220),
            display: 'block'
        }
    },

    '.footer__registration-title': {
        ...titleFont,
        alignSelf: 'center',
        margin: 0,
        width: '100%',
        textAlign: 'center',

        [isDesktop]: {
            ...titleFont[isDesktop],
            alignSelf: 'flex-start',
            width: 'auto',
            textAlign: 'left'
        }
    },

    '.footer__registration-loyalty-description': {
        ...copyFont,
        alignSelf: 'center',
        margin: 0,
        textAlign: 'center',
        width: '100%',

        [isDesktop]: {
            ...copyFont[isDesktop],
            textAlign: 'left',
            width: 'auto'
        }
    },

    '.footer__registration-button': {
        ...buttonFont,
        backgroundColor: 'cav_red',
        border: '1px solid cav_red',
        cursor: 'pointer',
        width: '100%',
        maxWidth: '100%',
        height: pxToRem(35),
        opacity: 1,
        padding: `${pxToRem(10)} ${pxToRem(20)}`,

        '&:hover': {
            backgroundColor: 'white',
            borderColor: 'cav_red',
            color: 'cav_red'
        },

        [isDesktop]: {
            ...buttonFont[isDesktop],
            height: pxToRem(40),
            maxWidth: pxToRem(295),
            padding: `${pxToRem(12)} ${pxToRem(20)}`
        }
    },

    '.footer__registration-form': {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: pxToRem(5),
        width: '100%',

        [isDesktop]: {
            marginBottom: 'unset',
            width: pxToRem(300)
        }
    },

    '.footer__registration-form--error': {
        '.footer__registration-error': {
            display: 'block'
        }
    },

    '.footer__registration-form-group': {
        display: 'flex',
        flexDirection: 'column',
        gap: pxToRem(10),
        marginBottom: pxToRem(20),
        width: '100%',

        [isDesktop]: {
            marginBottom: pxToRem(25),
            width: 'auto'
        }
    },

    '.footer__registration-form-label': {
        ...textFont
    },

    '.footer__registration-form-required': {
        color: 'cav_red'
    },

    '.footer__registration-form-input': {
        ...textFont,
        border: '1px solid #000',
        padding: pxToRem(10),
        height: pxToRem(35),
        backgroundColor: 'transparent',
        width: '100%',
        maxWidth: '100%',

        '&::placeholder': {
            color: 'rgba(99, 99, 99, 0.8)'
        },

        [isDesktop]: {
            height: pxToRem(40),
            width: 'auto',
            maxWidth: pxToRem(298)
        }
    },

    '.footer__registration-icons': {
        display: 'flex',
        gap: pxToRem(20),
        alignItems: 'center',
        width: 'auto',
        justifyContent: 'center',
        margin: 0,
        padding: 0,
        listStyle: 'none',

        '> *': {
            margin: 0,
            padding: 0,
            flexShrink: 0,
            lineHeight: 0
        },

        a: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: pxToRem(25),
            height: pxToRem(25),
            margin: 0,
            padding: 0
        },

        [isDesktop]: {
            justifyContent: 'flex-start'
        }
    },

    '.footer__registration-icon': {
        width: pxToRem(25),
        height: pxToRem(25),
        maxWidth: pxToRem(25),
        maxHeight: pxToRem(25),
        display: 'block',
        color: 'black'
    },

    '.footer__support': {
        width: '100%',
        ...sectionListStyles,

        [isDesktop]: {
            width: 'auto'
        }
    },

    '.footer__about': {
        width: '100%',
        ...sectionListStyles,

        [isDesktop]: {
            width: 'auto'
        }
    },

    '.footer__customer-service': {
        width: '100%',
        textAlign: 'left',
        marginTop: pxToRem(10),
        marginBottom: 0,
        ...sectionListStyles,

        [isDesktop]: {
            width: 'auto',
            textAlign: 'unset',
            marginTop: 0,
            marginBottom: 0
        }
    },

    '.footer__terms': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: pxToRem(20),
        textAlign: 'center',
        width: '100%',

        '.legal-links': {
            ...termsRowFont,
            width: '100%',
            margin: 0,
            padding: 0,

            a: {
                ...termsRowChildStyles,
                ...termsLinkHover
            },

            '.footer__section-link': {
                ...termsRowChildStyles,
                ...termsLinkHover
            },

            span: termsRowChildStyles
        },

        '.copyright': {
            ...termsRowFont,
            width: '100%',
            margin: 0,
            padding: 0,

            p: termsRowChildStyles,
            a: {
                ...termsRowChildStyles,
                ...termsLinkHover
            },

            '.footer__section-link': {
                ...termsRowChildStyles,
                ...termsLinkHover
            },

            '.footer__text-copy': termsRowChildStyles,

            span: termsRowChildStyles
        }
    },

    '.pipe-separator, .pipe-seperator': {
        ...termsRowChildStyles,
        margin: `0 ${pxToRem(10)}`
    }
}
